// @flow
import * as React from 'react';
import Modal from 'react-modal';

import AdminNewAutoMessageContainer from './AdminNewAutoMessageContainer';
import AdminNewAutoMessage from './AdminNewAutoMessage';
import ConfirmDialog from 'components/ConfirmDialog';
import Dialog from 'components/Dialog';

import type { AutoMessageTabKey } from './';

type Props = {
  messageUuid?: ?string,
  viewingOrgUuid?: string,
  onBack: () => void,
  startingTab?: ?AutoMessageTabKey,
};

type State = {
  confirmBeforeClosingDialog: boolean,
  showConfirmationDialog: boolean,
};

class AdminNewAutoMessageModal extends React.Component<Props, State> {
  state = {
    confirmBeforeClosingDialog: false,
    showConfirmationDialog: false,
  };

  handleBack = () => {
    if (this.state.confirmBeforeClosingDialog) {
      this.setState({ showConfirmationDialog: true });
      return;
    }
    this.props.onBack();
  };

  showConfirmDialog = () => {
    this.setState({ showConfirmationDialog: false });
  };

  hideConfirmDialog = () => {
    this.setState({ showConfirmationDialog: false });
  };

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.showConfirmationDialog}>
          <ConfirmDialog
            actionButtonText="Discard"
            cancelButtonText="Cancel"
            onCancel={this.hideConfirmDialog}
            onConfirm={this.props.onBack}
            onRequestHide={this.hideConfirmDialog}
            title="Your changes will be discarded. Are you sure you want to close the flow?"
          />
        </Modal>
        <Dialog full>
          <AdminNewAutoMessageContainer
            viewingOrgUuid={this.props.viewingOrgUuid}
            messageUuid={this.props.messageUuid}>
            {props => (
              <AdminNewAutoMessage
                {...props}
                onBack={this.handleBack}
                onFieldChange={() => this.setState({ confirmBeforeClosingDialog: true })}
                onResetFieldChange={() => this.setState({ confirmBeforeClosingDialog: false })}
                startingTab={this.props.startingTab}
              />
            )}
          </AdminNewAutoMessageContainer>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default AdminNewAutoMessageModal;
